
"use client";

import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Info, CheckCircle, XCircle } from "lucide-react";
import Link from "next/link";

const COOKIE_CONSENT_KEY = "luehmann_it_cookie_consent";

export function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // This code runs only on the client
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (consent !== "accepted" && consent !== "declined") {
      setIsVisible(true);
    }
  }, []);

  const handleConsent = (consentType: "accepted" | "declined") => {
    localStorage.setItem(COOKIE_CONSENT_KEY, consentType);
    setIsVisible(false);
    // Hier könnten Sie basierend auf consentType weitere Logik auslösen,
    // z.B. Tracking-Skripte laden, falls "accepted" und Analytics-Cookies verwendet werden.
    // Für den Moment wird nur die Banner-Sichtbarkeit gesteuert.
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6 lg:p-8 flex justify-center">
      <Card className="w-full max-w-2xl shadow-2xl bg-card/90 backdrop-blur-md border-border/60">
        <CardHeader className="flex flex-row items-start space-x-3 pb-3">
          <Info className="h-6 w-6 text-primary flex-shrink-0 mt-1" />
          <div>
            <CardTitle className="text-xl">Ihre Privatsphäre ist uns wichtig</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-foreground/90">
            Wir verwenden auf unserer Webseite clientseitigen Speicher (LocalStorage), um Ihre Auswahl bezüglich dieses Banners zu speichern und Ihnen so die wiederholte Anzeige zu ersparen.
            Wir setzen aktuell keine Cookies für Analyse- oder Marketingzwecke ein. Durch Klicken auf &quot;Akzeptieren&quot; stimmen Sie der Speicherung Ihrer Präferenz zu.
            Weitere Informationen finden Sie in unserer{" "}
            <Link href="/datenschutz" className="underline text-primary hover:text-primary/80">
              Datenschutzerklärung
            </Link>.
          </p>
        </CardContent>
        <CardFooter className="flex flex-col sm:flex-row justify-end space-y-2 sm:space-y-0 sm:space-x-3">
          <Button variant="outline" onClick={() => handleConsent("declined")} className="w-full sm:w-auto">
            <XCircle className="mr-2 h-5 w-5" />
            Ablehnen
          </Button>
          <Button onClick={() => handleConsent("accepted")} className="bg-accent hover:bg-accent/90 text-accent-foreground w-full sm:w-auto">
            <CheckCircle className="mr-2 h-5 w-5" />
            Akzeptieren
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
